(function() {
  var DESKTOP_BREAKPOINT = 768;
  var resizeTimer = null;

  function getSections(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    return Array.prototype.slice.call(root.querySelectorAll('.promociones-bancarias'));
  }

  function getCards(section) {
    return Array.prototype.slice.call(section.querySelectorAll('.promociones-bancarias__card'));
  }

  function getCardMain(card) {
    return card.querySelector('.promociones-bancarias__card-main');
  }

  function getCardHeader(card) {
    return card.querySelector('.promociones-bancarias__card-header');
  }

  function getCardDescription(card) {
    return card.querySelector('.promociones-bancarias__card-descripcion');
  }

  function resetCardHeights(cards) {
    cards.forEach(function(card) {
      var cardMain = getCardMain(card);
      var cardHeader = getCardHeader(card);
      var cardDescription = getCardDescription(card);
      if (cardMain) cardMain.style.minHeight = '';
      if (cardHeader) cardHeader.style.minHeight = '';
      if (cardDescription) cardDescription.style.minHeight = '';
    });
  }

  function withCardsCollapsed(cards, callback) {
    var section = cards[0] ? cards[0].closest('.promociones-bancarias') : null;
    var states = cards.map(function(card) {
      return Array.prototype.slice.call(card.querySelectorAll('details')).map(function(details) {
        return {
          element: details,
          open: details.hasAttribute('open')
        };
      });
    });

    if (section) section.dataset.promocionesBancariasMeasuring = 'true';

    states.forEach(function(cardStates) {
      cardStates.forEach(function(item) {
        item.element.removeAttribute('open');
      });
    });

    var result = callback();

    states.forEach(function(cardStates) {
      cardStates.forEach(function(item) {
        if (item.open) item.element.setAttribute('open', 'open');
      });
    });

    if (section) section.dataset.promocionesBancariasMeasuring = 'false';

    return result;
  }

  function groupCardsByRow(cards) {
    var rows = [];

    cards.forEach(function(card) {
      var top = Math.round(card.getBoundingClientRect().top);
      var row = rows.find(function(entry) {
        return Math.abs(entry.top - top) <= 2;
      });

      if (!row) {
        row = { top: top, cards: [] };
        rows.push(row);
      }

      row.cards.push(card);
    });

    return rows;
  }

  function equalizeSection(section) {
    var cards = getCards(section);
    if (!cards.length) return;

    resetCardHeights(cards);

    withCardsCollapsed(cards, function() {
      if (window.innerWidth >= DESKTOP_BREAKPOINT) {
        groupCardsByRow(cards).forEach(function(row) {
          var maxHeight = 0;
          var maxHeaderHeight = 0;
          var maxDescriptionHeight = 0;

          row.cards.forEach(function(card) {
            var cardMain = getCardMain(card);
            var cardHeader = getCardHeader(card);
            var cardDescription = getCardDescription(card);
            if (!cardMain) return;
            maxHeight = Math.max(maxHeight, Math.ceil(cardMain.getBoundingClientRect().height));
            if (cardHeader) {
              maxHeaderHeight = Math.max(maxHeaderHeight, Math.ceil(cardHeader.getBoundingClientRect().height));
            }
            if (cardDescription) {
              maxDescriptionHeight = Math.max(maxDescriptionHeight, Math.ceil(cardDescription.getBoundingClientRect().height));
            }
          });

          row.cards.forEach(function(card) {
            var cardMain = getCardMain(card);
            var cardHeader = getCardHeader(card);
            var cardDescription = getCardDescription(card);
            if (cardMain) cardMain.style.minHeight = maxHeight + 'px';
            if (cardHeader) cardHeader.style.minHeight = maxHeaderHeight + 'px';
            if (cardDescription) cardDescription.style.minHeight = maxDescriptionHeight + 'px';
          });
        });
      } else {
        var mobileMax = 0;
        var mobileHeaderMax = 0;
        var mobileDescriptionMax = 0;

        cards.forEach(function(card) {
          var cardMain = getCardMain(card);
          var cardHeader = getCardHeader(card);
          var cardDescription = getCardDescription(card);
          if (!cardMain) return;
          mobileMax = Math.max(mobileMax, Math.ceil(cardMain.getBoundingClientRect().height));
          if (cardHeader) {
            mobileHeaderMax = Math.max(mobileHeaderMax, Math.ceil(cardHeader.getBoundingClientRect().height));
          }
          if (cardDescription) {
            mobileDescriptionMax = Math.max(mobileDescriptionMax, Math.ceil(cardDescription.getBoundingClientRect().height));
          }
        });

        cards.forEach(function(card) {
          var cardMain = getCardMain(card);
          var cardHeader = getCardHeader(card);
          var cardDescription = getCardDescription(card);
          if (cardMain) cardMain.style.minHeight = mobileMax + 'px';
          if (cardHeader) cardHeader.style.minHeight = mobileHeaderMax + 'px';
          if (cardDescription) cardDescription.style.minHeight = mobileDescriptionMax + 'px';
        });
      }
    });

    section.classList.remove('promociones-bancarias--pending-equalize');
    section.classList.add('promociones-bancarias--ready');
  }

  function equalizeAllSections(scope) {
    getSections(scope).forEach(equalizeSection);
  }

  function scheduleEqualize(scope, delay) {
    window.clearTimeout(resizeTimer);
    if (delay === 0) {
      equalizeAllSections(scope);
      return;
    }
    resizeTimer = window.setTimeout(function() {
      equalizeAllSections(scope);
    }, typeof delay === 'number' ? delay : 50);
  }

  function openPromoModal(btn) {
    var modalId = btn.getAttribute('data-modal-id');
    if (!modalId) return;

    var modal = document.getElementById(modalId);
    if (!modal && modalId.indexOf('PromoBancoModal-') === 0) {
      var allModals = document.querySelectorAll('modal-dialog[id^="PromoBancoModal"]');
      for (var i = 0; i < allModals.length; i++) {
        if (modalId.indexOf(allModals[i].id) === 0) {
          modal = allModals[i];
          break;
        }
      }
    }

    if (modal && typeof modal.show === 'function') {
      modal.querySelectorAll('.pdp-calculador__icon-box').forEach(function(box) {
        box.classList.remove('is-active');
      });
      modal.querySelectorAll('.pdp-calculador__panel').forEach(function(panel) {
        panel.classList.remove('is-active');
      });

      var firstIcon = modal.querySelector('.pdp-calculador__icon-box');
      var firstPanel = modal.querySelector('.pdp-calculador__panel');
      if (firstIcon) firstIcon.classList.add('is-active');
      if (firstPanel) firstPanel.classList.add('is-active');

      modal.show(btn);
    }
  }

  function handleDocumentClick(e) {
    var btn = e.target.closest('[data-promo-popup]');
    if (btn) {
      var section = btn.closest('.promociones-bancarias');
      if (!section) return;
      e.preventDefault();
      openPromoModal(btn);
      return;
    }

    var stripBtn = e.target.closest('[data-popup-card-index]');
    if (!stripBtn) return;

    var strip = stripBtn.closest('.pdp-calculador__icon-strip');
    if (!strip) return;

    var modal = strip.closest('modal-dialog');
    if (!modal) return;

    var index = stripBtn.getAttribute('data-popup-card-index');
    modal.querySelectorAll('.pdp-calculador__icon-box').forEach(function(box) {
      box.classList.remove('is-active');
    });
    modal.querySelectorAll('.pdp-calculador__panel').forEach(function(panel) {
      panel.classList.remove('is-active');
    });

    stripBtn.classList.add('is-active');
    var panel = modal.querySelector('.pdp-calculador__panel[data-popup-card-index="' + index + '"]');
    if (panel) panel.classList.add('is-active');
  }

  function bindSection(section) {
    if (section.dataset.promocionesBancariasBound === 'true') return;
    section.dataset.promocionesBancariasBound = 'true';

    Array.prototype.slice.call(section.querySelectorAll('details')).forEach(function(details) {
      details.addEventListener('toggle', function() {
        if (section.dataset.promocionesBancariasMeasuring === 'true') return;
        scheduleEqualize(section, 0);
      });
    });

    Array.prototype.slice.call(section.querySelectorAll('img')).forEach(function(img) {
      if (img.complete) return;
      img.addEventListener('load', function() {
        scheduleEqualize(section, 0);
      }, { once: true });
      img.addEventListener('error', function() {
        scheduleEqualize(section, 0);
      }, { once: true });
    });
  }

  function init(scope) {
    getSections(scope).forEach(function(section) {
      bindSection(section);
      equalizeSection(section);
    });
  }

  document.addEventListener('click', handleDocumentClick);
  window.addEventListener('resize', function() {
    scheduleEqualize(document, 80);
  });
  window.addEventListener('load', function() {
    scheduleEqualize(document, 0);
  });
  document.addEventListener('DOMContentLoaded', function() {
    init(document);
  });
  document.addEventListener('shopify:section:load', function(event) {
    init(event.target);
  });
})();
